import { memo, type ReactNode } from 'react';

import { SegmentedControl, type SegmentedControlOption } from '@air/component-segmented-control';

import { ShareModalRow } from '~/components/ShareModal/components/ShareModalRow';

export type SegmentedControlRowProps = {
  label: string;
  labelAccessory?: ReactNode;
  options: SegmentedControlOption[];
  selectedOption: SegmentedControlOption;
  onSelect: (option: SegmentedControlOption) => void;
  'data-testid'?: string;
};

export const SegmentedControlRow = memo(
  ({
    label,
    labelAccessory,
    options,
    selectedOption,
    onSelect,
    'data-testid': dataTestId,
  }: SegmentedControlRowProps) => {
    return (
      <ShareModalRow data-testid={dataTestId} label={label} labelAccessory={labelAccessory}>
        <SegmentedControl
          color="blue"
          onSelect={onSelect}
          options={options}
          selectedOption={selectedOption}
          size="xsmall"
        />
      </ShareModalRow>
    );
  },
);

SegmentedControlRow.displayName = 'SegmentedControlRow';
